<template lang="pug">
  div(v-cloak).sub-page
    CommonHeader
    main
      v-container
        h1 ご入力内容の確認
        v-layout.container.justify-center(row wrap)
          v-layout.text-xs-center.my-5.stepper(row wrap)
            v-flex(xs12)
              p.my-3 ご注文の流れ
              ul.list-unstyled.multi-steps
                li
                  | ご注文内容の確認
                  br
                  | お客様情報・配送指定
                li.is-active ご入力内容の確認
                li 注文完了
        v-layout.pa-3.mt-3.white_container.justify-center(row wrap)
          h2 ショッピングカート
          p.text-xs-center.my-4 ご注文内容をご確認ください。
          v-container
            v-layout.cart_list(row wrap v-for="(item, index) in cart" :key="item.key")
              v-flex.text-xs-center.index(md1) {{index + 1}}
              v-flex.text-md-left.mb-2(md6) {{item.name}}
              v-flex(md1 xs3)
                span 数量 {{item.num|number}}
              v-flex.text-xs-right(md3 xs9)
               |単価（税込） {{item.price|number}}
               br
               |価格（税込） {{item.sub_total|number}}

            div.mt-3(v-if="cart.length === 0")
              v-alert(type="info" color="error" outline :value="true") カートに商品がありません。
            v-container.btn_wrap
              v-layout(row wrap)
                v-flex(xs12 md4 offset-xs0 offset-md4)
                  router-link(to="cart" tag="div")
                    v-btn(color="brown darken-4" flat outline round block)
                      span 入力画面に戻る

          v-container(grid-list-md)
            v-layout(row wrap v-if="customer")
              v-flex(xs12)
                h2 お客様情報
                v-subheader ご入力内容をご確認ください。

              v-flex(xs12)
                .app-line
                  span.app-line-title お名前
                  span.app-line-text {{customer.name}}
                  span.app-line-suffix 様

                .app-line
                  span.app-line-title E-mail
                  span.app-line-text {{customer.email}}
                  span.app-line-suffix &nbsp;

                .app-line
                  span.app-line-title 郵便番号
                  span.app-line-text {{customer.zipcode}}
                  span.app-line-suffix &nbsp;

                .app-line
                  span.app-line-title 住所
                  span.app-line-text {{customer.zipcode}} {{customer.pref}} {{customer.address1}} {{customer.address2}}
                  span.app-line-suffix &nbsp;

                .app-line
                  span.app-line-title 電話番号
                  span.app-line-text {{customer.tel}}
                  span.app-line-suffix &nbsp;

                .app-line
                  span.app-line-title 配送希望日
                  span.app-line-text {{customer.desired_delivery_date|date}}
                  span.app-line-suffix &nbsp;

                .app-line
                  span.app-line-title 配送希望時間帯
                  span.app-line-text {{customer.desired_delivery_time}}
                  span.app-line-suffix &nbsp;

                v-layout(row wrap v-show="!item.hide" v-for='(item, index) in schedule' :key="index")
                  p.mt-3 【{{ item.title }} 】
                    ul.ml-2(v-for='item in item.list')
                      li {{ item.topic }}

          v-container(v-if="cart.length > 0")
            v-layout(row rwap)
              v-flex(xs12 sm6 offset-sm6 md4 offset-md8)
                .app-line
                  span.app-line-title 小計
                  span.app-line-text {{summary.total|number}}
                  span.app-line-suffix 円
                .app-line
                  span.app-line-title 送料
                  span.app-line-text {{summary.delivery_fee|number}}
                  span.app-line-suffix 円
                .app-line
                  span.app-line-title 代引手数料
                  span.app-line-text {{summary.cod_fee|number}}
                  span.app-line-suffix 円
                .app-line
                  span.app-line-title 合計金額
                  span.app-line-text {{summary.grand_total|number}}
                  span.app-line-suffix 円

          v-layout.mt-5
            v-flex(md4 offset-md4)
              v-btn(
                color="primary"
                round
                block
                outline
                @click="sendRequest"
                :disabled="exclusiveLock"
                :loading="exclusiveLock"
                )
                span 購入を確定

          v-layout.mt-2
            v-flex(xs12 md6 offset-md3)
              v-checkbox(
                color="secondary"
                label="お客様情報を保存"
                v-model="rememberMe"
                hide-details
              )
              span(style="font-size: .9rem") 入力したお客様情報をブラウザに保持しておくことで、次回入力時に同じ内容を設定することができます。

    CommonFooter
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import CommonHeader from '@/app/pages/Landing/Header.vue'
import CommonFooter from '@/app/pages/Landing/Footer.vue'

export default {
  components: {
    CommonHeader,
    CommonFooter
  },
  mounted () {
    this.$vuetify.theme.error = '#9e5d0d'
    this.$vuetify.theme.accent = '#9e5d0d'
  },
  data () {
    return {
      rememberMe: true,
      exclusiveLock: false,
      schedule: [
        {
          hide: true,
          title: '年末年始の配送スケジュールについて',
          list: [{
            'topic': '本年の最終出荷分は12月27日（金）AM11時までとなります。'
          }, {
            'topic': '12月27日（土）AM11時以降のご注文分は年末年始明けの手配になりますのでご注意ください。'
          }, {
            'topic': '年明けは1月6日（月）からご注文を承ります。'
          }]
        }
      ]
    }
  },
  created () {
    this.reloadCustomer()
    this.reloadCart()
  },
  computed: {
    ...mapGetters('app/shop', [
      'request',
      'cart',
      'cartNum',
      'customer',
      'summary',
      'deliveryTimeTable',
      'prefs'
    ]),
    selectionTimes () {
      return this.deliveryTimeTable.map(time => {
        return {
          text: time
        }
      })
    }
  },
  methods: {
    ...mapActions('app/shop', ['reloadCustomer', 'reloadCart', 'clearCart', 'forgetMe']),
    sendRequest () {
      // console.log(this.request)
      if (this.exclusiveLock) {
        return
      }
      this.exclusiveLock = true
      this.$ajax.post('/resources/orders', this.request)
        .then((response) => {
          // console.log(response)
          this.clearCart()
          if (!this.rememberMe) {
            this.forgetMe()
          }
          this.$router.push(`/cart_danke/${response.data.id}`)
        })
        .catch((error) => {
          console.dir(error)
        })
        .finally(() => {
          this.exclusiveLock = false
        })
    }
  }
}
</script>

<style scoped lang="stylus">
// breakpoint
screen-xs = 600px
screen-sm = 960px
breakpoint(bpName)
    for name in bpName
        if name == 'sm-up'
            @media only screen and (min-width: screen-xs)
                {block}
        if name == 'xs'
            @media only screen and (max-width: screen-xs)
                {block}
        if name == 'sm'
            @media only screen and (max-width: screen-sm)
                {block}

// color
$color-primary = #502e28
$color-secondary = #ecddbc
.section
  border-top 1px solid $color-primary
  padding 2rem 0

</style>



// WEBPACK FOOTER //
// src/app/pages/Landing/CartConfirm/index.vue